import React from 'react'
import './services.css'
import servicebg from '../../../assets/servicebg.jpg'
import Footer from '../Footer/Footer'

// Import images for service cards
import offshoreRigImg from '../../../assets/architecture.jpg'
import drillingPlatformImg from '../../../assets/52381.jpg'
import structuralEnhancementsImg from '../../../assets/10664.jpg'
import pipelineImg from '../../../assets/2080.jpg'
import naturalGasImg from '../../../assets/2149057713.jpg'

const Services = () => {
    return (
        <>
            <div className="services-container">
                <div className='service-image'>
                    <img src={servicebg} alt="Energy service background" />
                    <div className='service-overlay'></div>
                </div>

                <div className="services-text">
                    <h1>What we do?</h1>
                    <div 
                        data-aos="fade-right"
                        data-aos-easing="linear"
                        data-aos-duration="1000"
                        className="block">
                    </div>
                </div>
            </div>

            <div className="company-mission">
                <div className="mission-content">
                    <p>
                        Our industry is experiencing fundamental challenges. From climate 
                        change and geopolitics to the energy markets, we are facing new 
                        realities. Some see them as threats. At  Helix Energy Solutions, we believe 
                        our job is to turn them into opportunities. That's why we're looking for 
                        new ways to utilize our expertise in the energy industry, exploring 
                        opportunities in new energy and driving innovation in oil and gas 
                        worldwide. We are committed to a low-carbon future, aiming to become 
                        the world's most carbon-efficient oil and gas producer while also 
                        pioneering innovation in offshore wind and renewables.
                    </p>
                </div>
            </div>

            <div className="service-pillars">
                {/* Responsive service pillars */}
                <div className="pillar-container">
                    <div className="pillar">
                        <h2>Facing Industry Challenges</h2>
                        <p>
                            Our industry is experiencing fundamental challenges, 
                            from climate change and geopolitics to shifting 
                            energy markets. While some perceive these changes 
                            as threats, at  Helix Energy Solutions, we see them as 
                            opportunities to innovate and grow.
                        </p>
                    </div>
                    
                    <div className="pillar">
                        <h2>Leveraging Expertise for Innovation</h2>
                        <p>
                            We are committed to utilizing our expertise in the 
                            energy industry to explore opportunities in both new 
                            energy and traditional oil and gas sectors at Helix 
                            Energy Group. Our efforts are focused on driving 
                            innovation globally, ensuring we stay at the forefront 
                            of industry advancements.
                        </p>
                    </div>
                    
                    <div className="pillar">
                        <h2>Commitment to a Low-Carbon Future</h2>
                        <p>
                            Recognizing the imperative of a low-carbon future, 
                            our ambition at  Helix Energy Solutions is to become the 
                            world's most carbon-efficient oil and gas producer. 
                            Additionally, we are dedicated to advancing offshore 
                            wind and renewable energy solutions, solidifying our 
                            role as leaders in sustainable energy innovation.
                        </p>
                    </div>
                </div>
            </div>

            <div className="fields-section">
                <h2>Fields and platforms</h2>
                <p>
                    We're one of the world's largest offshore operators, the largest operator on the Globe 
                    continental shelf. This page is an overview of the fields we are currently developing, and 
                    those in operation-in Turkey, and around the world.
                </p>
                
                <div className="service-card">
                    <div className="service-card-content">
                        <div className="image">
                            <img src={drillingPlatformImg} alt="Drilling and Riser Platforms" />
                        </div>
                        <div className="card-text">
                            <h3>Drilling and Riser Platforms</h3>
                            <p>
                                Key milestones this year include the successful 
                                development of the drilling platform and the riser 
                                platform. These essential structures form the 
                                backbone of our offshore operations, ensuring 
                                stability and efficiency in our drilling processes.
                            </p>
                        </div>
                    </div>
                    
                    <div className="service-card-content">
                        <div className="image">
                            <img src={structuralEnhancementsImg} alt="Structural Enhancements" />
                        </div>
                        <div className="card-text">
                            <h3>Structural Enhancements</h3>
                            <p>
                                Another significant achievement is the construction 
                                of the bridge connecting the riser and drilling 
                                platforms. Additionally, we have completed three 
                                steel jackets for the drilling platform, the processing 
                                platform, and the utility and living quarters.
                            </p>
                        </div>
                    </div>
                    
                    <div className="service-card-content">
                        <div className="image">
                            <img src={pipelineImg} alt="Pipeline and Power Connectivity" />
                        </div>
                        <div className="card-text">
                            <h3>Pipeline and Power Connectivity</h3>
                            <p>
                                In terms of connectivity, we have laid 400 km of oil 
                                and gas pipelines and 200 km of power cables. These 
                                critical installations are pivotal in ensuring the 
                                seamless transport of resources and the reliable 
                                delivery of power across our operational sites.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="natural-gas-section">
                <div className="natural-gas-content">
                    <h2>Natural Gas</h2>
                    <p>
                        Traditionally, most of  Helix Energy Solutions's gas has been sold through 
                        long-term contracts to large European gas companies and suppliers. In 
                        the absence of a separate market price for gas, the sale price has often 
                        been indexed to the price of oil. In the USA,  Helix Energy Solutions has 
                        shares and production in three premium shale oil and gas plays. Gas is 
                        used for energy production, heating, and industrial purposes. Through 
                        transport agreements to New York City and Toronto, residents can keep 
                        winter temperatures at bay with shale gas from the Marcellus field. 
                        Through commercial negotiations with our counterparts, we have 
                        modernized most of our long-term contracts and gradually moved 
                        away from oil indexing. The price of gas is now directly linked to market 
                        prices.
                    </p>
                </div>
                <div className="natural-gas-logo">
                    <img src={naturalGasImg} alt=" Helix Energy Solutions Logo" />
                </div>
            </div>
   
            <Footer />
        </>
    )
}

export default Services